import styled from "styled-components"
import {
  validColor,
  validBackground,
  darkBorder,
  darkFontColor,
  darkBackground,
} from "./helpers"

export const StyledCheckboxWrapper = styled.div`
  display: ${({ hidden }) => (hidden ? "none" : "grid")};
  align-content: flex-start;
  grid-column: span 2 / auto;
  margin: 12px 0;
  width: 100%;

  ${(props) =>
    props.loading &&
    `
        opacity: .5;
        pointer-events: none;
    `}
`

export const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & label {
    width: auto;
    font-size: 16px;
    line-height: 20px;
    font-family: "EFCircularWeb-Book";
    color: ${({ isDark }) => darkFontColor(isDark)};

    & p,
    strong {
      color: ${({ isDark }) => darkFontColor(isDark)};
    }

    @media (max-width: 1024px) {
      font-size: 14px;
      line-height: 18px;
    }
  }

  & a {
    font-size: 16px;
    color: inherit;
    text-decoration: underline;
    font-family: "EFCircularWeb-Book";
    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }

  & div {
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
    height: 30px;
    width: 30px;
    position: relative;
    margin: 0 16px 0 0;
    border-radius: 4px;
    cursor: pointer;
    background: ${({ isDark }) => darkBackground(isDark)};
    background: ${({ valid }) => validBackground(valid)};
    border: 1px solid rgba(0, 0, 0, 0.25);
    border: 2px solid ${({ valid }) => validColor(valid)};
  }

  & input {
    display: none;
    padding: 14px 16px;
    font-size: 14px;
  }

  & svg {
    height: 16px;
  }

  > svg {
    margin: 0.6rem 2.8rem 0 0.8rem;
    @media (max-width: 1024px) {
      margin: 0.6rem 2.2rem 0 0.8rem;
    }
  }

  > div {
    min-width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
